<template>
  <div style="padding-bottom: 80px;" v-if="isShow">
    <!-- <van-nav-bar
      title="高级机械维修工程"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #right>
        <van-icon name="gengduo1" size="28" />
      </template>
    </van-nav-bar> -->
    <div class="detail-cont">
      <div class="job-header">
        <h2>{{ detail.jobName }}</h2>
        <div class="wages">{{ detail.salary }}/月</div>
        <ul class="condition">
          <li>
            <van-icon name="renyuan"></van-icon>
            <span>招{{ detail.jobNum || "0" }}人</span>
          </li>
          <li>
            <van-icon name="shijian"></van-icon>
            <span>{{ detail.expLevel }}</span>
          </li>
          <li>
            <van-icon name="xueli"></van-icon>
            <span>{{ detail.eduLevel }}</span>
          </li>
        </ul>
        <div class="title-02" v-if="detail.positionStatus == 1">
          <h3>职位福利</h3>
          <span
            class="icon-more"
            @click="showMore"
            v-if="
              detail.positionLableList && detail.positionLableList.length > 5
            "
            :class="{ active: active }"
            >{{ brandFold ? "查看全部" : "收起" }}</span
          >
        </div>
        <ul class="welfare" :class="{isall:brandFold}" v-if="detail.positionStatus == 1">
          <li v-for="item in detail.positionLableList" :key="item.index">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <ul class="edit-icon">
        <li>
          <van-icon name="fenxiang"></van-icon>
          <span @click="onShare">分享</span>
        </li>
        <li>
          <van-icon name="jubao"></van-icon>
          <span @click="reportClick">举报</span>
        </li>
      </ul>
      <div class="contact">
        <div class="person">
          <img v-if="detail.userRecruitersAvatar" :src="detail.userRecruitersAvatar" />
          <img v-else :src="require('@/assets/img/avatar.png')" />
          <h3>
            {{ detail.userRecruitersName }}
            <small>{{ detail.userRecruitersJobTitle }}</small>
          </h3>
        </div>
        <!-- <van-icon name="gengduo"></van-icon> -->
      </div>
      <div v-if="detail.positionStatus == 1">
        <div class="title-01">
          <h2>职位描述</h2>
        </div>
        <pre class="detail-desc">{{ detail.jobDescription }}</pre>
        <div class="line"></div>
        <div class="company" @click="enterpriseRoute">
          <div class="company-info">
            <img
              v-if="detail.enterpriseLogoUrl"
              :src="detail.enterpriseLogoUrl"
            />
            <img v-else src="../../../../assets/img/logo2.png" />
            <div class="header-top">
              <h3>{{ detail.enterpriseName }}</h3>
              <ul>
                <li>{{ detail.personnelSize }}</li>
                <li>{{ detail.tradesFullName }}</li>
              </ul>
            </div>
          </div>
          <van-icon name="gengduo"></van-icon>
        </div>

        <div class="map">
          <div class="location">
            <h3>工作地址：</h3>
            <p>{{ detail.workAddress || "上海" }}</p>
          </div>
          <div id="allmap" style="width: 100%;height:300px;"></div>
        </div>
      </div>
      <div v-else>
        该职位已关闭
      </div>
    </div>
    <div class="fixed-bottom" v-if="detail.positionStatus == 1">
      <div class="collection">
        <van-icon
          name="collection"
          :class="{ active: activeCollect }"
          @click="toggleClass"
        ></van-icon>
        <span>收藏职位</span>
      </div>
      <van-button
        @click="resumeClick"
        v-if="!sendStatus"
        type="primary"
        color="linear-gradient(to right top, #2F72F6,#1C54CF)"
        round
        >投 递 简 历</van-button
      >
      <van-button v-else type="primary" class="btn-gray" color="#EEEFF1" round
        >已 投 递</van-button
      >
    </div>
    <van-share-sheet
      v-model="showShare"
      title="我要分享"
      :options="options"
      @select="onReport"
    />
    <!--弹出举报-->
    <transition name="fade">
      <div class="filter-cont report" v-show="reportPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenReportPop"></van-icon>
          <h2>举报</h2>
        </div>
        <h3>举报理由</h3>
        <ul class="filter-list">
          <li
            v-for="(item, index) in reasonList"
            :key="index"
            :class="{ checked: item.dictKey == form.reportReason }"
            @click="selectReason(item.dictKey)"
          >
            <span>{{ item.dictValue }}</span>
          </li>
        </ul>
        <h3>举报说明</h3>
        <div class="textarea">
          <textarea
            v-model="form.reportDescription"
            placeholder="请输入您的反馈，我们将不断为您改进，一经核实
  将尽快联系您～"
            name=""
            id=""
            cols="30"
            rows="10"
          >
          </textarea>
        </div>
        <van-uploader
          v-model="fileList"
          multiple
          :max-count="1"
          :after-read="uploadImage"
        />
        <div class="fixed-bottom">
          <van-button
            @click="submitReport"
            type="primary"
            class="btn-blue"
            color="linear-gradient(to right top, #2F72F6,#1C54CF)"
            round
            >提 交</van-button
          >
        </div>
      </div>
    </transition>
    <create-resume-dialog ref="resumeDialog"></create-resume-dialog>
  </div>
</template>

<script>
import BMap from 'BMap'
import { tenant } from '@utils/constant'
import { CONSTANT } from '../../../../utils/constant/data'
import createResumeDialog from '../components/createResumeDialog'
import native from '@utils/native'
import { throttle } from "@utils/index";

export default {
  name: 'jobDetail',
  components: { createResumeDialog },
  data() {
    return {
      isShow: false,
      detail: {},
      brandFold: true,
      active: false,
      activeCollect: false,
      sendStatus: false,
      more: '',
      r: 0,
      reportPop: false,
      showShare: false,
      fileList: [],
      selectReason(index) {
        this.form.reportReason = index
      },
      form: {
        reportReason: '',
        reportType: CONSTANT.REPORT_TYPE.POSITION,
        reportPositionId: this.$route.query.id,
        reportDescription: '',
        reportEvidenceUrl: ''
      },
      options: [
        [
          {
            name: '微信',
            icon: require('../../../../assets/img/share/wechat.png'),
            type: 'wx'
          },
          {
            name: '朋友圈',
            icon: require('../../../../assets/img/share/pyq.png')
          },
          { name: 'QQ', icon: require('../../../../assets/img/share/qq.png') },
          {
            name: '微博',
            icon: require('../../../../assets/img/share/weibo.png')
          }
        ]
        // [
        //   {
        //     name: '我要举报',
        //     icon: require('../../../../assets/img/share/jubao.png')
        //   }
        // ]
      ],
      reasonList: []
    }
  },
  computed: {},
  methods: {
    onload(wdJobPositionId) {
      this.module.api.posDetail({
        params: { wdJobPositionId },
        success: res => {
          this.detail = res
          this.isShow = true
          this.localMap(res.workAddress || '上海')
        }
      })
      if (this.$cookie.get('token')) {
        this.module.api.posCollectStatus({
          params: { wdJobPositionId },
          success: res => {
            this.activeCollect = res
          }
        })
        this.module.api.posSendStatus({
          params: { wdJobPositionId },
          success: res => {
            this.sendStatus = res
          }
        })
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    /**
     * 分享
     */
    onShare() {
      // this.showShare = true
      console.log("//"+document.location.host + "/jdjob/image/avatar.png")

      rmt.configUI({
        moreBox: {
          wechat: 'enable',       //"分享到微信"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          wechatMoment: 'enable', //"分享到朋友圈"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          qq: 'enable',           //"分享到QQ"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          qqZone: 'enable',       //"分享到QQ空间"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          weibo: 'enable',        //"分享到微博"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          theme: 'enable',        //"字体"与"配色"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          report: 'dismiss',       //"举报"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          copyLink: 'enable'      //"拷贝链接"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        },
      })

      //标题
      let title = this.detail.jobName
      //简介
      let summary = this.detail.jobDescription
      //链接地址
      let link = window.location.href
      //配图
      let imageUrl = this.detail.userRecruitersAvatar || "//"+document.location.host + "/image/avatar.png"

      rmt.configShare({
        //设置"分享到微信"数据
        wechat: {
          title, 
          summary, 
          link,
          imageUrl 
        },
        //设置"分享到朋友圈"数据
        wechatMoment: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到QQ"数据
        qq: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到QQ空间"数据
        qqZone: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到微博"数据
        weibo: {
          title,
          summary,
          link,
          imageUrl
        }
      });

      rmt.openMoreBox({
          wechat: 'enable',
          wechatMoment: 'enable',
          qq: 'enable',
          qqZone: 'enable',
          weibo: 'enable',
          theme: 'enable',  //字体/配色
          report: 'dismiss',
          copyLink: 'enable',
      });


    },
    /**
     * 提交举报
     */
    submitReport() {
      if (this.fileList && this.fileList.length > 0) {
        this.form.reportEvidenceUrl = this.fileList[0].url
      }
      this.module.api.report({
        params: this.form,
        success: records => {
          this.reportPop = false
          this.toast('举报成功')
        }
      })
    },
    /**
     * 投递简历
     */
    resumeClick: throttle(function(){
      let rtnVal = native.shmedia2.isRmtNative()
      console.log(rtnVal)
      if (rtnVal === 40) {
        // 由于延时未调用查询简历接口
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data)
            this.$cookie.set('hasResume', data)
            if (data === true) {
              // 已登录已创建简历
              const wdJobPositionId = this.$route.query.id
              this.module.api.posSendResume({
                method: 'post',
                params: { wdJobPositionId },
                success: data => {
                  this.sendStatus = data
                }
              })
            } else {
              // 登录了没有创建简历的情况
              this.$refs.resumeDialog.isShowDia()
            }
          }
        })
      } else if (rtnVal === 10) {
        // 已登录已创建简历
        const wdJobPositionId = this.$route.query.id
        this.module.api.posSendResume({
          method: 'post',
          params: { wdJobPositionId },
          success: data => {
            this.sendStatus = data
          }
        })
      } else if (rtnVal === 0) {
        // 端外
        window.AppSiteConfig.showDownDialog()
      } else if (rtnVal === 20) {
        // 登录了没有创建简历的情况
        this.$refs.resumeDialog.isShowDia()
      }
    },2000),
    /**
     * 文件上传
     */
    uploadImage(file) {
      const params = new FormData()
      params.append('file', file.file)
      this.module.api.putFile({
        data: params,
        success: res => {
          this.fileList.pop()
          this.fileList.push({
            url: res.link,
            isImage: true
          })
        }
      })
    },
    /**
     * 加载举报原因
     */
    loadReportType() {
      this.module.api.bizDict({
        params: { code: 'report_reason_type' },
        success: records => {
          this.reasonList = records
        }
      })
    },
    /**
     * 收藏职位
     */
    toggleClass:throttle(function(){
      // this.active = !this.active
      let rtnVal = native.shmedia2.isRmtNative()
      console.log(rtnVal)
      if (rtnVal === 40) {
        // 由于延时未调用查询简历接口
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data)
            this.$cookie.set('hasResume', data)
            if (data === true) {
              // 已登录已创建简历
              const wdJobPositionId = this.$route.query.id
              this.module.api.posCollection({
                params: { wdJobPositionId },
                success: res => {
                  if (res.key == 1 && res.result) {
                    this.activeCollect = true
                  } else if (res.key == 0 && res.result) {
                    this.activeCollect = false
                  } else {
                    this.toast('收藏失败')
                  }
                }
              })
            } else {
              // 登录了没有创建简历的情况
              this.$refs.resumeDialog.isShowDia()
            }
          }
        })
      } else if (rtnVal === 10) {
        // 已登录已创建简历
        const wdJobPositionId = this.$route.query.id
        this.module.api.posCollection({
          params: { wdJobPositionId },
          success: res => {
            if (res.key == 1 && res.result) {
              this.activeCollect = true
            } else if (res.key == 0 && res.result) {
              this.activeCollect = false
            } else {
              this.toast('收藏失败')
            }
          }
        })
      } else if (rtnVal === 0) {
        // 端外
        window.AppSiteConfig.showDownDialog()
      } else if (rtnVal === 20) {
        // 登录了没有创建简历的情况
        this.$refs.resumeDialog.isShowDia()
      }
    },1000),
    showMore() {
      this.brandFold = !this.brandFold
      this.active = !this.active
    },
    hiddenReportPop() {
      this.reportPop = false
    },
    onReport(val) {
      console.log(val)
      this.showShare = false
    },
    /**
     * 举报
     */
    reportClick:throttle(function(){
      native.shmedia2.goToLoginFormTheApp(()=>{
        let token = this.$cookie.get("token")
        if(token){
          // 清空表单
          this.form = {
            reportReason: '',
            reportType: CONSTANT.REPORT_TYPE.POSITION,
            reportPositionId: this.$route.query.id,
            reportDescription: '',
            reportEvidenceUrl: ''
          }
          this.fileList = []
          this.reportPop = true
        }
      })
    },1000) ,
    /**
     * 加载地图
     */
    localMap(address) {
      // 百度地图
      this.$nextTick(function() {
        let that = this
        // 在此调用api
        let map = new BMap.Map('allmap')
        map.centerAndZoom('上海', 12)

        var myGeo = new BMap.Geocoder()
        myGeo.getPoint(
          address,
          function(point) {
            var infoOpts = {
              width: 100, // 信息窗口宽度
              height: 50, // 信息窗口高度
              title: '工作地点', // 信息窗口标题
              message: '工作地点'
            }
            if (point) {
              map.centerAndZoom(point, 16)
              let marker = new BMap.Marker(point)
              map.addOverlay(marker)

              var infoWindow = new BMap.InfoWindow(
                '地址：' + address,
                infoOpts
              ) // 创建信息窗口对象
              map.openInfoWindow(infoWindow, point) // 开启信息窗口
            } else {
              map.centerAndZoom('上海市', 15)
              let marker = new BMap.Marker(point)
              map.addOverlay(marker)
            }
          },
          '上海市'
        )
      })
    },
    enterpriseRoute(){
      this.$router.push({path: 'companyDetail', query: {id:this.detail.enterpriseId}})
    }
  },
  mounted() {
    this.$route.query.id && this.onload(this.$route.query.id)
    this.loadReportType()
  }
}
</script>

<style lang="less" scoped>
  /deep/.van-popup{
    min-height: auto;
  }
.isall{
  height: 36px;
  overflow: hidden;
}
/deep/.van-nav-bar {
  background: #1c54cf;
  .van-nav-bar__title,
  i {
    color: #fff;
    font-weight: normal;
  }
}
/deep/.van-share-sheet__title {
  font-size: 14px;
  color: #adb0b6;
}
/deep/.van-share-sheet__options {
  .van-share-sheet__option {
    width: 25%;
  }
  .van-share-sheet__icon {
    width: auto;
    height: 30px;
  }
}
/deep/.van-uploader {
  margin: 10px 16px;
  .van-uploader__preview-delete-icon {
    top: -3px;
  }
}
.textarea {
  margin:0 16px;
  textarea{
    display: block;
    width: 100%;
    min-height: 170px;
    background: #f8f9fb;
    border-radius: 4px;
    border: none;
    padding: 16px;
    font-size: 14px;
    &::-webkit-input-placeholder {
      color: #ccc;
    }
  }
}
.fixed-bottom {
  padding: 10px 16px 20px;
  button {
    flex: 1;
  }
}
.detail-desc {
  max-width: 100%;
  overflow: auto;
  padding: 5px 20px;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: break-word;
  color:#5C5D5F;
  line-height: 1.8;
}
.edit-icon{
  border-bottom: 1px solid #eee;
  margin:0 16px;
  padding-bottom: 16px;
}
</style>
